import PropTypes from 'prop-types';
import { DimensionPropType } from '../prop-types/dimension';

export const PackagePropType = PropTypes.shape({
  packageTypeId: PropTypes.string,
  packageId: PropTypes.string,
  carrierId: PropTypes.string,
  name: PropTypes.string,
  isCustom: PropTypes.bool,
  isHidden: PropTypes.bool,
  dimensions: DimensionPropType,
});

/**
 * @typedef {object} PackagePropType
 * @property {string} packageTypeId
 * @property {string} packageId
 * @property {string} carrierId
 * @property {string} name
 * @property {boolean} isCustom
 * @property {boolean} isHidden
 * @property {DimensionsPropType} dimensions
 */
